import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateControlResultAssignmentsForUserMutation } from "org/user/queries/useUpdateControlResultAssignmentsForUserMutation";

import { buildPatchControlResultsBody } from "./buildPatchControlResultsBody";
import { ControlResultRow } from "./useUserControlResultListTable";

interface UseRemoveControlResultAssignmentUtilsProps {
    userId: number;
    selectedRows: Row<ControlResultRow>[];
    deselectAll: () => void;
}

export function useRemoveControlResultAssignmentUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemoveControlResultAssignmentUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate, isPending, error, reset } =
        useUpdateControlResultAssignmentsForUserMutation();

    const removeAccessRightToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeAccessRight = () => {
        mutate(
            {
                userId,
                data: {
                    newUserId: null,
                    controlResultSteps:
                        buildPatchControlResultsBody(selectedRows),
                },
            },
            {
                onSuccess: () => {
                    deselectAll();
                    setIsModalOpen(false);
                },
                // On failure the modal stays open; `error` drives the notice.
            }
        );
    };

    return {
        removeAccessRightToolState,
        isRemoveAccessRightModalOpen: isModalOpen,
        removeAccessRightError: error,
        // Reset on open (not close) so the notice stays put during the close
        // animation and a stale error can't reappear next time.
        openRemoveAccessRightModal: () => {
            reset();
            setIsModalOpen(true);
        },
        closeRemoveAccessRightModal: () => setIsModalOpen(false),
        removeAccessRight,
        isRemovingAccessRight: isPending,
    };
}
